import { t } from "@/i18n-js/instance";
import { LabelSm } from "@/react/components/shared/uikit/Typography/components/Label/LabelSm";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useChangePlanFormContext } from "./ChangePlanFormContext";

interface AddPaymentMethodProps {
  className?: string;
}

export const AddPaymentMethod = ({
  className = "mt-6",
}: AddPaymentMethodProps) => {
  const { CardElement, handleOnChangeCard } = useChangePlanFormContext();

  return (
    <div className={classNames(className)}>
      <LabelSm weight="semibold">
        {t(
          "member_profile_modal.billing.subscriptions.add_payment_method.card_details",
        )}
      </LabelSm>

      <div className="mt-1 rounded border border-solid border-gray-300 p-3">
        <CardElement
          options={{ hidePostalCode: true }}
          onChange={handleOnChangeCard}
        />
      </div>
    </div>
  );
};
